// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"_2x6cL","light":"_2-GO8","button":"_6Hb0V","navigation":"_2JOhg","phone":"fqbNV","email":"_2XUhw","address":"_2PzwK","socialLinks":"_2PYDX"};